import { cloneDeep } from "lodash";

import memoize from "memoize-weak";

import { reflow as reflowSignatureCase, unstickStudent as unstickStudentSignatureCase } from "./Kind/SignatureCase";

export const weakMemoizedReflow = memoize(reflow);
export function reflow(data, documentKind: DocumentKind, documentId: number, options: {showCardTest?: (card: DocSectionType<InlineHtmlNode>) => boolean} = {}) {
  const clonedData = cloneDeep(data);

  switch (documentKind) {
    case "signature_case":
    case "signature_case_cme":
      return reflowSignatureCase(clonedData, documentId, options);
    default:
      return clonedData;
  }
}

export const weakMemoizedUnstickStudent = memoize(unstickStudent);
export function unstickStudent(data, documentKind: DocumentKind, options: {showCardTest?: (card: DocSectionType<InlineHtmlNode>) => boolean} = {}) {
  switch (documentKind) {
    case "signature_case":
    case "signature_case_cme":
      return unstickStudentSignatureCase(data, options);
    default:
      return data;
  }
}
